import { buildProps, definePropType } from '@jdesign-vue/utils'
import { useSizeProp } from '@jdesign-vue/hooks'

import type { ExtractPropTypes } from 'vue'
import type { Language } from '@jdesign-vue/locale'
import type { ButtonConfigContext } from '@jdesign-vue/components/button'
import type { MessageConfigContext } from '@jdesign-vue/components/message'
import type { DrawerConfigContext } from '@jdesign-vue/components/drawer'
import type { TableConfigContext } from '@jdesign-vue/components/table'

export type ExperimentalFeatures = {
  // TO BE Defined
}

export const configProviderProps = buildProps({
  /**
   * @description Controlling if the users want a11y features
   */
  a11y: {
    type: Boolean,
    default: true,
  },
  /**
   * @description Locale Object
   */
  locale: {
    type: definePropType<Language>(Object),
  },
  /**
   * @description global component size
   */
  size: useSizeProp,
  /**
   * @description button related configuration, [see the following table](#button-attributes)
   */
  button: {
    type: definePropType<ButtonConfigContext>(Object),
  },
  /**
   * @description features at experimental stage to be added, all features are default to be set to false                                                                                | ^[object]
   */
  experimentalFeatures: {
    type: definePropType<ExperimentalFeatures>(Object),
  },
  /**
   * @description Controls if we should handle keyboard navigation
   */
  keyboardNavigation: {
    type: Boolean,
    default: true,
  },
  /**
   * @description message related configuration, [see the following table](#message-attributes)
   */
  message: {
    type: definePropType<MessageConfigContext>(Object),
  },
  /**
   * @description global Initial zIndex
   */
  zIndex: Number,
  /**
   * @description global component className prefix (cooperated with [$namespace](https://github.com/jdesign-vue/jdesign-vue/blob/dev/packages/theme-chalk/src/mixins/config.scss#L1)) | ^[string]
   */
  namespace: {
    type: String,
    default: 'jd',
  },
  loading: {
    type: definePropType<{ background: string }>(Object),
  },
  /**
   * @description drawer related configuration, [see the following table](#drawer-config-context)
   */
  drawer: {
    type: definePropType<DrawerConfigContext>(Object),
  },
  table: {
    type: definePropType<TableConfigContext>(Object),
  },
  /**
   * @description first day of the week (0=Sunday, 1=Monday, ..., 6=Saturday)
   */
  weekStart: {
    type: Number,
    default: 1,
  },
} as const)
export type ConfigProviderProps = ExtractPropTypes<typeof configProviderProps>
